import React from "react";
import CourseItems from "../components/CourseItems";

export default function CourseList(...props) {
    return (
        <div className="Courses">
            <div className="AppContainer">
                <h1 className="SectionTitle">My Courses</h1>
                <CourseItems />
            </div>
        </div>
    );
}
